import moment from "moment";

export function fDateMoment(date) {
  // Create a Moment object from the input date and convert it to UTC mode
  // The .utc() function parses the date as UTC and keeps it in UTC mode.
  // If `date` is already a UTC string, moment() will parse it as such,
  // then .utc() ensures subsequent operations are in UTC.
  const utcMoment = moment(date).utc();

  // Format the UTC Moment object to "dd MMMM yyyy"
  // 'DD' for day of the month (01-31)
  // 'MMMM' for full month name (January-December)
  // 'YYYY' for four-digit year
  return utcMoment.format("DD MMMM YYYY");
}
